"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("./constants");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Notification = (0, _react.memo)(({
  notification,
  onRead,
  onHide,
  actionHandler,
  Icon = _styles.DefaultIcon,
  theme
}) => {
  const timerId = (0, _react.useRef)(null);
  const handleClick = (0, _react.useCallback)((ntfn, action) => {
    if (onHide) onHide(ntfn, action);
  }, [onHide]);
  const handleCloseNotification = (0, _react.useCallback)(ntfn => () => {
    handleClick(ntfn, {
      title: 'HIDE'
    });
  }, [handleClick]);
  (0, _react.useEffect)(() => {
    const delay = notification.delay !== (null || undefined) ? notification.delay : 3000;
    if (delay) {
      timerId.current = setTimeout(() => {
        handleClick(notification);
      }, delay);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [notification, handleClick]);
  const handleMouseEnter = () => {
    if (timerId) {
      clearTimeout(timerId.current);
    }
  };
  const handleAction = (0, _react.useCallback)((action, ntfn) => {
    if (onRead) onRead(ntfn);
    if (actionHandler) actionHandler(action, ntfn);
    handleClick(ntfn, action);
  }, [actionHandler, handleClick, onRead]);
  const getNotificationActions = (0, _react.useCallback)(ntfn => {
    if (ntfn && ntfn.actions && !!ntfn.actions.length) {
      let actions = ntfn.actions;
      if (theme.name === 'mds') {
        actions = actions.filter(action => !_constants.defaultToastActions.some(act => act.id === action.id));
      }
      return actions.map(action => ({
        name: action.title,
        variant: action.variant,
        handler: () => handleAction(action, ntfn)
      }));
    }
    return [];
  }, [handleAction, theme.name]);
  const rawActions = (0, _react.useMemo)(() => getNotificationActions(notification), [notification, getNotificationActions]);
  return _react.default.createElement(_styles.NotificationItem, {
    category: (notification.category || _constants.TOAST_CATEGORIES.INFO).toLowerCase(),
    onMouseEnter: handleMouseEnter
  }, _react.default.createElement(_styles.TextContainer, null, _react.default.createElement(_styles.ToastIcon, {
    component: _react.default.createElement(Icon, null),
    category: notification.category
  }), _react.default.createElement(_styles.NotificationText, null, notification.text)), _react.default.createElement(_styles.ButtonMenuContainer, null, notification.actions && !!notification.actions.length && rawActions.map((item, index) => _react.default.createElement(_styles.Button, {
    variant: item.variant,
    mode: theme.name === 'mds' ? 'inline' : 'default',
    key: index,
    title: item.name,
    type: "button",
    onClick: item.handler,
    category: notification.category
  })), theme.name === 'mds' && _react.default.createElement(_styles.MDSCloseIcon, {
    category: notification.category,
    onClick: handleCloseNotification(notification)
  })));
});
var _default = exports.default = (0, _styledComponents.withTheme)(Notification);